import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h3" }, "Claim BLUES", -1)
const _hoisted_3 = {
  key: 0,
  class: "mt-s4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
  /*#__PURE__*/_createTextVNode(" Sorry, you are not listed as a Blueshift investor."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Contact us for questions: ")
], -1)
const _hoisted_5 = { class: "flex align-items-center mt-s1 text-sm justify-content-end" }

import ClaimWallet from '@/views/vesting/claimForm/ClaimWallet.vue';
import ClaimableAmount from '@/views/vesting/claimForm/ClaimableAmount.vue';
import ExternalLink from '@/components/ExternalLink.vue';
import { useVesting } from '@/composables/core/useVesting';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { vestingStateIsReady, isNotListed } = useVesting();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(ClaimWallet),
    _createVNode(ClaimableAmount),
    (_unref(vestingStateIsReady) && _unref(isNotListed))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ExternalLink, {
              label: "Telegram",
              url: "https://t.me/blueshift",
              icon: "",
              class: "mr-s4"
            }),
            _createVNode(ExternalLink, {
              label: "E-mail",
              url: "mailto:hello@blueshift.fi",
              icon: ""
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})